module.exports = __webpack_public_path__ + "static/media/threat_token.03085d70.png";